import React from "react";

const NavBar = () => (
  <div className="bg-danger py-2 px-2">
    <span>
      <div className="btn-sm text-decoration-none bg-danger rounded-0 text-light">
      <a className="btn-sm text-decoration-none bg-danger rounded-0 text-light" href="/">
        &nbsp; Algorithms Visualiser
      </a>
      </div>
    </span>
  </div>
);

export default NavBar;
